// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimTransferCalculationsDto
 */
export interface IClaimTransferCalculationsDto {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof IClaimTransferCalculationsDto
     */
    transfers?: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof IClaimTransferCalculationsDto
     */
    repayments?: { [key: string]: number; };
}

/**
 * Check if a given object implements the IClaimTransferCalculationsDto interface.
 */
export function instanceOfIClaimTransferCalculationsDto(value: object): value is IClaimTransferCalculationsDto {
    return true;
}

export function IClaimTransferCalculationsDtoFromJSON(json: any): IClaimTransferCalculationsDto {
    return IClaimTransferCalculationsDtoFromJSONTyped(json, false);
}

export function IClaimTransferCalculationsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimTransferCalculationsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'transfers': json['transfers'] == null ? undefined : json['transfers'],
        'repayments': json['repayments'] == null ? undefined : json['repayments'],
    };
}

export function IClaimTransferCalculationsDtoToJSON(json: any): IClaimTransferCalculationsDto {
    return IClaimTransferCalculationsDtoToJSONTyped(json, false);
}

export function IClaimTransferCalculationsDtoToJSONTyped(value?: IClaimTransferCalculationsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transfers': value['transfers'],
        'repayments': value['repayments'],
    };
}

